require('./bootstrap');
require('./app/index');
require('./app/wizards/index');
require('./app/my_orders/index');


// WEBPACK FOOTER //
// ./resources/js/app.js